export default "__VITE_ASSET__7cc031f1__"